var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 20 20",
  style: {
    enableBackground: "new 0 0 20 20"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#858282;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,16h-3.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H16c1.7,0,3-1.3,3-3s-1.3-3-3-3c-0.4,0-0.7,0.1-1,0.2 c-0.2,0.1-0.5,0-0.6-0.2s-0.1-0.4,0.1-0.6C14.8,8,15,7.5,15,7c0-1.1-0.9-2-2-2c-0.6,0-1.2,0.3-1.6,0.8C11.2,6.1,11,6.5,11,6.9 c0,0.2-0.2,0.4-0.4,0.5s-0.4,0-0.5-0.2l0,0C10,7,9.9,6.8,9.7,6.7C8.8,5.6,7.4,5,6,5c-2.8,0-5,2.2-5,5s2.2,5,5,5h2.5 C8.8,15,9,15.2,9,15.5S8.8,16,8.5,16H6c-3.3,0-6-2.7-6-6s2.7-6,6-6c1.6,0,3.1,0.6,4.3,1.8c0.1-0.2,0.2-0.4,0.3-0.6 C11.1,4.5,12.1,4,13,4c1.7,0,3,1.3,3,3c0,0.4-0.1,0.7-0.2,1c0.1,0,0.1,0,0.2,0c2.2,0,4,1.8,4,4S18.2,16,16,16L16,16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12.9,12.1l-2-2c-0.2-0.2-0.5-0.2-0.7,0l-2,2c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l1.1-1.1v3.8 c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-3.8l1.1,1.1c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1C13,12.7,13,12.3,12.9,12.1z"
})));
export default SvgCloudUpload;